import script from "./FormDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormDate.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__